import React, { Component } from 'react';

export class NoAccess extends Component {
    render() {
        return <div>
            <p>Доступ запрещён</p>
        </div>;
    }
}